import { get } from 'lodash';
import { getExperienceOffers } from '@origin-digital/features';

export const getExperienceOffer = (mbox) => get(getExperienceOffers(mbox), '[0]');
